import { z } from 'zod/v3';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { zIsoDate } from '../../common/utils';
import { zDataObjectType } from './zDataObjectType';

export const DataVersionStatusSchema = z.enum([
  'DRAFT',
  'CONFIRMED',
  'CONF_PUB',
  'CONF_PREPUB',
  'CONF_WAIT',
]);

export const DataObjectVersionSchema = z.object({
  id: z.number(),
  statusId: z.number(),
  statusCode: DataVersionStatusSchema.nullable(),
  versionNumber: z.number().nullable(),
  minorNumber: z.number().nullable(),
  valueDate: zIsoDate().nullable(),
  dataObjectDescriptionVersionId: z.number().nullable(),
  dataObjectId: z.number().nullable(),
  typeId: z.number().nullable(),
  calculationTime: zIsoDateTime(),
});

export const DataObjectRelationVersionSchema = DataObjectVersionSchema.omit({
  dataObjectDescriptionVersionId: true,
  dataObjectId: true,
  typeId: true,
  statusId: true,
}).extend({
  newerVersionAvailable: z.boolean(),
  emptyVersion: z.boolean(),
  dataConflict: z.boolean().nullable(),
  validationErrorLevelId: z.number().nullable(),
  calculationSources: z.string().nullish(),
});

export const DataObjectVersionSourceSchema = z.object({
  descriptionId: z.number(),
  groupId: z.number(),
  type: zDataObjectType,
  code: z.string(),
  name: z.string(),
  valueDate: zIsoDate(),
  versionId: z.number(),
  versionNumber: z.number().nullable(),
  minorNumber: z.number().nullable(),
  versionStatusId: z.number(),
  calculationTime: zIsoDateTime(),
});
